import React from 'react'
import '../styles/gallery.scss'

class Gallery extends React.Component {
    constructor({images}) {
        super();
        this.images = images;
        this.index = 0;
    }

    componentDidMount() {
        this.imageEls = [].slice.call(this.gallery.querySelector('li'));
    }

    slideToImage() {
        this.gallery.scrollTo({
            top: 0,
            left: this.imageEls[this.index].offsetLeft,
            behavior: 'smooth'
        });
    }

    previousImage() {
        if (this.index === 0) {
            this.index = this.images.length - 1;
        } else {
            this.index--;
        }
        this.slideToImage();
    }

    nextImage() {
        if (this.index === this.images.length - 1) {
            this.index = 0;
        } else {
            this.index++;
        }
        this.slideToImage();
    }

    render () {
        return (
            <article className='gallery'>
                {this.images.length > 1 ? <button onClick={this.nextImage()}></button> : ''}
                <ul className='gallery__track' ref={n => {this.gallery = n}}>
                    {this.images.map((image,index) => (<li key={index}>{image}</li>))}
                </ul>
                {this.images.length > 1 ? <button onClick={this.prevImage()}></button> : ''}
            </article>
        )
    }
}

export default Gallery